import { createApp } from "vue";
import ProgressSpinner from "primevue/progressspinner";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import PrimeVue from "primevue/config";
import InputText from "primevue/inputtext";
import InputMask from "primevue/inputmask";
import SelectButton from "primevue/selectbutton";
import Dialog from "primevue/dialog";
import { setupInterceptors } from "@/api";
import logger from "@/utils/logger";
import "./index.css";

const app = createApp(App);
setupInterceptors();
app
  .use(logger)
  .use(PrimeVue)
  .use(store)
  .use(router)
  .component("InputText", InputText)
  .component("InputMask", InputMask)
  .component("SelectButton", SelectButton)
  .component("ProgressSpinner", ProgressSpinner)
  .component("Dialog", Dialog)
  .mount("#app");
